/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.28.0
 */

import { EInquiryTableType } from '@/main/pages/PageHistoryInquiry/types';

import { useLazyPostInquirySyncQuery, useLazyPostOtherInquirySyncQuery } from '../store';

/**
 * Use postInquirySync or postOtherInquirySync depending on @param inquiryTableType
 */
export const useInquirySyncRequest = ({ inquiryTableType }: { inquiryTableType: EInquiryTableType }) => {
    const isDefaultInquiryTableType = inquiryTableType === EInquiryTableType.DEFAULT;

    const getInquiryPostResponse = useLazyPostInquirySyncQuery();
    const getOtherInquiryPostResponse = useLazyPostOtherInquirySyncQuery();

    if (isDefaultInquiryTableType) {
        return getInquiryPostResponse;
    } else {
        return getOtherInquiryPostResponse;
    }
};
